// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"776":"bf44eea8","988":"3deae28f"}[chunkId] + ".css";
};